import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {LabelHeaderContainerModel} from '../../../../../../models/aggregates/erp/label';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelHdrService extends BaseApiTemplateService<LabelHeaderContainerModel> {

  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'labels-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'labels-hdr';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.MICRO_SERVICES_PREFIX + Core2Config.ERP_PREFIX + 'labels-hdr';
    this.httpClient = http;
  }

  public getByCriteriaAdvancedSearchPublicEp(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<LabelHeaderContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'label/hdrs/advanced-search/public-ep';
    }
    else {
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'label/hdrs/advanced-search/public-ep';
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<LabelHeaderContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
